import { Box, Button, Dialog, Divider, IconButton, TextField, Typography } from '@mui/material'
import { CloseIcon } from '../../assets/icons'
import { FileOutput } from '../../types/procedureOutputs'
import { useState } from 'react'
import { trpc } from '../../core/trpc'
import toast from 'react-hot-toast'
import { LoadingButton } from '@mui/lab'
import { getFileNameExtension, stripFileNameExt } from '../../utils/helpers'

type RenameFileProps = {
  setFile: React.Dispatch<React.SetStateAction<FileOutput | undefined>>
  file: FileOutput
  refetch: () => void
}

const RenameFile = ({ setFile, file, refetch }: RenameFileProps) => {
  const [fileName, setFileName] = useState(stripFileNameExt(file.name))
  const updateFileMutation = trpc.file.updateFile.useMutation({
    onSuccess: () => {
      refetch()
      toast.success('File name updated')
      setFile(undefined)
    }
  })

  return (
    <Dialog open>
      <Box className="p-5 w-[350px]">
        <Box className="flex justify-between items-center mb-4">
          <Typography className="text_xl_medium">Rename File</Typography>
          <IconButton onClick={() => setFile(undefined)}>
            <CloseIcon fontSize="small" className="text-grey-700" />
          </IconButton>
        </Box>
        <TextField
          placeholder="Enter new file name"
          fullWidth
          value={fileName}
          onChange={(e) => {
            setFileName(stripFileNameExt(e.target.value))
          }}
        />
        <Divider className="my-5" />
        <Box className="flex justify-end gap-3">
          <Button onClick={() => setFile(undefined)} variant="outlined">
            Cancel
          </Button>
          <LoadingButton
            variant="contained"
            onClick={() => {
              const fileExt = getFileNameExtension(file.name)
              updateFileMutation.mutate({ id: file.id, name: fileName.concat(fileExt ? `${fileExt}` : '') })
            }}
          >
            Save
          </LoadingButton>
        </Box>
      </Box>
    </Dialog>
  )
}

export default RenameFile
